import { useTranslation } from '../../../../../../i18n/hooks/useTranslation';

const inputClass = 'w-full rounded-xl border border-[#ECE8E4] bg-white px-3 py-2.5 text-[14px] text-[#3D3833] outline-none transition-colors focus:border-primary focus:ring-2 focus:ring-primary/20 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100';

export default function AtsCvSectionTitleInput({ value, onChange }) {
    const { t } = useTranslation();

    return (
        <div className="mb-3">
            <label className="mb-1 block text-[12px] font-semibold text-[#6B635C] dark:text-zinc-400">
                {t('atsCvMaker.sectionTitleLabel')}
            </label>
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={t('atsCvMaker.sectionTitlePlaceholder')}
                className={inputClass}
            />
            <p className="mt-1 text-[11px] text-[#A8A099] dark:text-zinc-500">
                {t('atsCvMaker.sectionTitleHint')}
            </p>
        </div>
    );
}
